module.exports = __webpack_public_path__ + "static/media/gabs.33ec987d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gabs.jpg
// module id = 733
// module chunks = 0